import { Button, DatePicker, Select } from 'antd';
import * as React from 'react';
import './FilterDialogMobile.scss';
import { IconFilter } from '../../../../../../assets/index';
import Modal from 'antd/lib/modal/Modal';
import { useState } from 'react';
import moment from 'moment';
const { RangePicker } = DatePicker;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';
const FilterDialogMobile = (props) => {
  const { fetListCampaign } = props;
  const [dialogFilterDate, setDialogFilterDatee] = useState([
    moment().subtract(3, 'month'),
    moment(),
  ]);
  const [filterTypeDialog, setFilterTypeDialog] = useState('all');
  const onChangeFilterDialog = () => {
    let dataDto = {
      from: dialogFilterDate[0].format('HH:mm:ss DD-MM-YYYY'),
      to: dialogFilterDate[1].format('HH:mm:ss DD-MM-YYYY'),
    };
    if (filterTypeDialog !== 'all') {
      dataDto = {
        ...dataDto,
        type: filterTypeDialog,
      };
    }
    setModalVisible(false);
    fetListCampaign(dataDto);
  };
  const [modalVisible, setModalVisible] = React.useState(false);
  const onChangeDateDialog = (date) => {
    setDialogFilterDatee(date);
  };
  return (
    <div className='filter-dialog-mobile'>
      <Button
        size='small'
        icon={<IconFilter style={{ marginRight: 4 }} />}
        type='text'
        style={{
          display: 'flex',
          alignItems: 'center',
          fontSize: 14,
          marginBottom: 32,
          color: '#1A202C',
        }}
        onClick={() => setModalVisible(true)}
      >
        Bộ lọc
      </Button>
      <Modal
        title=''
        centered
        visible={modalVisible}
        footer={
          <Button
            onClick={onChangeFilterDialog}
            style={{
              width: 100,
              height: 40,
              background: '#ff3366',
              color: 'white',
              borderRadius: 8,
            }}
          >
            Lưu
          </Button>
        }
        // onOk={() => setModalVisible(false)}
        onCancel={() => setModalVisible(false)}
      >
        <div className='filter'>
          <span className='title-filter'>Thời gian</span>
          <RangePicker
            onChange={onChangeDateDialog}
            format={dateFormat}
            value={dialogFilterDate}
            allowClear={false}
            showTime
          />
        </div>

        <div className='filter'>
          <span className='title-filter'>Loại quảng cáo</span>
          <Select
            value={filterTypeDialog}
            RangePicker
            style={{ width: '100%' }}
            placeholder='Chọn loại'
            optionFilterProp='all'
            onChange={(value) => setFilterTypeDialog(value)}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option value='all'>Tất cả</Option>
            <Option value='link'>Text Links</Option>
            <Option value='banner'>Banner</Option>
          </Select>
        </div>
      </Modal>
    </div>
  );
};

export default FilterDialogMobile;
